export const toolbar = {
  root: {
    padding: '0',
  },
  colorScheme: {
    light: {
      root: {
        background: '{surface.0}',
        borderColor: '{colors.transparent}',
        borderRadius: '0',
      },
    },
  },
};
